export default __webpack_public_path__ + "static/media/allCategory.ef1433cb.svg";